export const GET_DASHBOARD_HOME = "GET_DASHBOARD_HOME";
export const GET_DASHBOARD_HOME_SUCCESS = "GET_DASHBOARD_HOME_SUCCESS";
export const GET_DASHBOARD_HOME_FAILURE = "GET_DASHBOARD_HOME_FAILURE";
